if (!customElements.get('load-more-grid')) {
  class LoadMoreGrid extends HTMLElement {
    connectedCallback() {
      this.step = parseInt(this.dataset.step, 10) || 6;
      this.items = Array.from(this.children);
      this.wrap = this.parentElement && this.parentElement.querySelector('[data-load-more-wrap]');
      this.button = this.wrap && this.wrap.querySelector('[data-load-more-btn]');

      if (!this.button || this.items.length <= this.step) return;

      this.shown = this.step;
      this.onClick = () => {
        this.shown += this.step;
        this.update();
        this.items[Math.min(this.shown, this.items.length) - 1].focus({ preventScroll: true });
      };

      this.update();
      this.wrap.classList.add('is-visible');
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
    }

    update() {
      this.items.forEach((item, index) => {
        const hidden = index >= this.shown;
        item.classList.toggle('is-load-hidden', hidden);
        item.setAttribute('tabindex', '-1');
        if (hidden) {
          item.setAttribute('aria-hidden', 'true');
        } else {
          item.removeAttribute('aria-hidden');
        }
      });

      if (this.shown >= this.items.length) this.wrap.classList.remove('is-visible');
    }
  }

  customElements.define('load-more-grid', LoadMoreGrid);
}
